import { Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  ({
    title: {
      display: 'flex',
      paddingTop: 16,
      paddingBottom: 16,
      '& h2': {
        marginRight: 24,
        padding: 0,
      },
    },
    titlePage: {
      marginTop: 24,
      marginBottom: 32,
    },
    cardProduit: {
      marginTop: 28,
    },
    btn: {
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      '& button': {
        marginLeft: 12,
      },
    },
    btnActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
      '& button': {
        marginLeft: 12,
      },
    },
    tableGaranties: {
      '& td': {
        '&:first-child': {
          paddingRight: 32,
        },
      },
      '& h4': {
        color: theme.palette.secondary.main,
        fontSize: 14,
      },
    },
    titleGaranties: {
      '& td': {
        paddingTop: 12,
        color: theme.palette.secondary.main,
      },
    },
    bloc: {
      border: '0.5px solid #d0d0d0',
      borderRadius: 12,
      padding: '12px 16px',
      marginBottom: 16,
      '& h4': {
        marginBottom: 4,
        fontSize: 14,
        color: theme.palette.secondary.main,
      },
      '& > div': {
        color: '#000',
        fontSize: 14,
        '& > p': {
          display: 'flex',
          '& > span': {
            display: 'block',
            width: 130,
            minWidth: 130,
            color: theme.palette.primary.main,
            fontSize: 13,
            paddingRight: 8,
          },
        },
      },
    },
    // INFORMATIONS
    blocInformations: {
      '& h4': {
        margin: 0,
      },
    },
    // AVANTAGE
    blocAvantages: {
      '& span': {
        width: 280,
        wordBreak: 'break-word',
      },
    },
    containerTitle: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    dateEcheance: {
      color: theme.palette.secondary.dark,
    },
    // RENOUVELLEMENT
    modeContainer: {
      display: 'flex',
      margin: '24px 0',
      '& > div:first-of-type': {
        marginLeft: 0,
      },
    },
    blocRenouvellement: {
      '& h4': {
        margin: 0,
      },
    },
    mode: {
      border: '.5px solid ' + theme.palette.primary.main,
      borderRadius: 12,
      padding: '28px 20px',
      textAlign: 'center',
      width: 152,
      margin: '0 8px 0 8px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      '& > button': {
        marginTop: 12,
      },
    },
    active: {
      borderColor: theme.palette.secondary.main,
    },
    // RESILIATION
    blocResiliation: {
      '& h4': {
        margin: 0,
      },
    },
    resiliationformBottom: {
      marginTop: '20px',
      '& > button': {
        marginTop: '34px',
      },
    },
    resiliationModale: {
      '& h3': {
        marginTop: '10px',
      },
      '& h4': {
        fontWeight: 'normal',
        marginTop: '20px',
      },
    },
    // DRAWER
    drawerPaper: {
      width: 300,
      flexShrink: 0,
      zIndex: 1,
      background: theme.palette.secondary.dark,
      overflow: 'initial',
      border: 'none',
    },
    drawerClosed: {
      transform: 'translateX(-284px) !important',
      visibility: 'visible !important',
      '& $drawerList': {
        transform: 'translateX(-20px)',
      },
    },
    drawerHeader: {
      marginTop: 104,
      display: 'flex',
      justifyContent: 'space-between',
    },
    btnRetour: {
      color: 'white',
      paddingLeft: 24,
    },
    closingBtn: {
      position: 'relative',
      left: 12,
      padding: 0,
      borderRadius: '100%',
      width: 25,
      height: 25,
      background: theme.palette.secondary.dark,
      border: '1px solid ' + theme.palette.primary.light,
      '& svg': {
        transform: 'rotate(90deg)',
        '& > g': {
          fill: theme.palette.primary.light,
        },
      },
      '&:hover, &:focus, &:active': {
        background: theme.palette.secondary.dark,
      },
    },
    closingClosedBtn: {
      '& svg': {
        transform: 'rotate(270deg)',
      },
    },
    drawerFilter: {
      padding: '24px 24px 0 24px',
    },
    drawerList: {
      overflowY: 'auto',
      overflowX: 'hidden',
      height: 'calc(100vh - 277px)',
      padding: '4px 24px',
    },
    titleDrawer: {
      color: 'white',
      fontFamily: 'Poppins',
      fontWeight: 'bold',
      marginBottom: 8,
    },
    // titlePage: {
    //   display: "flex",
    //   justifyContent: "space-between",
    //   alignItems: "flex-end",
    //   marginTop: 24,
    //   marginBottom: 32,

    //   "& h2": {
    //     whiteSpace: "nowrap",
    //     textOverflow: "ellipsis",
    //     overflow: "hidden",
    //   },
    // },
    titleConcession: {
      width: '78%',
    },
    content: {
      transition: 'all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    },
    drawerInformations: {
      width: 280,
      flexShrink: 0,
      zIndex: 1,
      boxShadow: '-1px 3px 13px -2px #c2c2c2',
    },
    drawerContent: {
      marginTop: 104,
      padding: 12,
    },
    blocContact: {
      border: '0.5px solid #d0d0d0',
      borderRadius: 12,
      padding: '12px 16px',
      background: 'white',
      maxWidth: 290,
      '& > h4': {
        fontSize: 17,
      },
      '& > p': {
        color: 'black',
        marginBottom: 8,
      },
      '& a': {
        color: theme.palette.secondary.main,
      },
    },
    adresse: {
      paddingLeft: 76,
    },
    textInfo: {
      textAlign: 'right',
    },
    // FIDELITE
    containerBlocFidelite: {
      display: 'flex',
    },
    contentInfoFidelite: {
      display: 'flex',
      color: theme.palette.secondary.main,
      alignItems: 'center',
      minWidth: 206,
      '& > div': {
        marginLeft: 8,
        marginRight: 42,
      },
      '& h1': {
        fontSize: 39,
        margin: 0,
        fontFamily: 'Poppins',
        fontWeight: '700',
        lineHeight: '32px',
      },
      '& h4': {
        fontSize: 18,
        margin: 0,
        fontFamily: 'Poppins',
        fontWeight: 400,
      },
      '& span': {
        color: theme.palette.primary.main,
        fontSize: 12,
      },
      '& svg': {
        fill: theme.palette.secondary.main,
      },
    },
    transactionArray: {
      marginTop: 24,
    },
    listeTransaction: {
      borderBottom: '1px solid ' + theme.palette.primary.light,
      padding: '24px 0',
      '& p': {
        display: 'flex',
        alignItems: 'center',
        lineHeight: '7px',
        '& span': {
          width: 78,
          marginBottom: 0,
        },
      },
    },
    '@media all and (max-width: 628px)': {
      title: {
        paddingLeft: 12,
        justifyContent: 'space-between',
        '& h2': {
          fontSize: 20,
          display: 'flex',
          flexDirection: 'column',
        },
      }, // AVANTAGE
      blocAvantages: {
        '& span': {
          width: '70%',
          marginBottom: 6,
        },
      },
      containerBlocFidelite: {
        flexDirection: 'column',
      },
      // RENOUVELLEMENT
      modeContainer: {
        flexDirection: 'column',
      },
      mode: {
        width: 'auto',
        margin: '8px 0 8px 0',
      },
      blocInformations: {
        '& > div > div > div > div ': {
          display: 'block',
        },
      },
    },
    // MANDAT RENOUVELLEMENT
    verifySepa: {
      display: 'flex',
      alignItems: 'center',
    },
    iconCheckSepa: {
      marginRight: 4,
      '& > g': {
        fill: theme.palette.success.main,
      },
    },
    iconCroixSepa: {
      marginRight: 4,
      '& > g': {
        fill: theme.palette.secondary.main,
      },
    },
    errorMandat: {
      marginBottom: 12,
    },
  } as any);

export default styles;
